<script lang="ts">import Action from '../Action/Action.svelte';
const { variant = 'button', colorMode, size = 'regular', disabled = false, altText = '', balanced = false, onClick = () => { }, modal, noArrow = false, preventOrphanIcon = false, text = '', class: className = '', ...rest } = $props();
</script>

<Action
  {...rest}
  as="button"
  class="Button {className}"
  {variant}
  {colorMode}
  {size}
  {disabled}
  {altText}
  {balanced}
  {onClick}
  {modal}
  {noArrow}
  {preventOrphanIcon}
  {text}
/>
